import get from 'lodash/get';
import isArray from 'lodash/isArray';

const requireAttribute = require.context('@/components/containers/pdp/attributes/', true, /[A-Z]\w+\.(vue)$/);

const Attributes = {
  dropdown: 'AttributeDropdown',
  swatch: 'AttributeColor',
  radio: 'ProductAttributeButtonGrid',
};

const AttributeRenderer = {
  props: {
    stockMessage: {
      type: Object,
      default: () => ({}),
    },
    renderStockStatus: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getAttributeMetadata(attribute) {
      const code = isArray(attribute) ? get(attribute, '[0].code') : attribute.code;
      return this.product.categorizationHierarchyMetadata.find((item) => item.code === code);
    },
    getAttributeMetadataCodes() {
      return this.product.categorizationHierarchyMetadata.map((metaItem) => metaItem.code);
    },
    getAttributeLabel(attribute) {
      const metadata = this.getAttributeMetadata(attribute);
      return get(metadata, 'options.displayName');
    },
    getAttributeComponent(attribute) {
      const metadata = this.getAttributeMetadata(attribute);
      const type = !metadata || !metadata.type || !(metadata.type in Attributes) ? 'dropdown' : metadata.type;
      return requireAttribute(`./${Attributes[type]}.vue`).default;
    },
  },
};

export {AttributeRenderer};
